// You can write more code here

import SquareSelectableCard, {
  SquareSelectableCardData,
} from '@/game/prefabs/GeneralUI/SquareSelectableCard';

export enum SpellID {
  fireball,
  iceBlast,
  arcaneBlast,
}

export interface SpellIconData extends SquareSelectableCardData {
  spellId: SpellID;
}

/* START OF COMPILED CODE */

export default class SpellIcon extends SquareSelectableCard {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // icon
    const icon = scene.add.sprite(0, 0, 'spell-icon-fire');
    icon.scaleX = 1.5;
    icon.scaleY = 1.5;
    this.add(icon);

    this.icon = icon;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private icon: Phaser.GameObjects.Sprite;

  /* START-USER-CODE */

  spell: SpellID = SpellID.fireball;

  awake(data: SpellIconData) {
    super.awake(data);
    this.setSpellID(data.spellId);
    return this;
  }

  getTextureFromSpellID(spellID: SpellID) {
    switch (spellID) {
      case SpellID.fireball:
        return 'spell-icon-fire';
      case SpellID.iceBlast:
        return 'spell-icon-ice';
      case SpellID.arcaneBlast:
        return 'spell-icon-arcane';
    }
  }

  setSpellID(spellID: SpellID) {
    this.spell = spellID;
    this.icon.setTexture(this.getTextureFromSpellID(spellID));
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
